import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Spinner from "../app/views/shared/Spinner";
import PricingForm from "./views/pages/pricing_form/PricingForm";
import BannerImageSelection from "./views/pages/homepage_banner/BannerImageSelection";
import CustomerShared from "./views/pages/customer_shared/CustomerShared";
import UserList from "./views/pages/user/UserList";
import CartList from "./views/pages/cart/CartList";
import CustomizeLocation from "./views/pages/customize_location/CustomizeLocation";
import PickupPoint from "./views/pages/customize_pickup_point/PickupPoint";
import PickupTime from "./views/pages/customize_pickup_time/PickupTime";
import DropPoint from "./views/pages/customize_drop_point/DropPoint";
import CustomizePricingForm from "./views/pages/customize_pricing_form/CustomizePricingForm";
import CustomizeCartList from "./views/pages/customize_cart/CustomizeCartList";
import CartDetails from "./views/pages/cart/CartDetails";
import CustomizeCartDetails from "./views/pages/customize_cart/CustomizeCartDetails";
import ContactUs from "./views/pages/contact_us/ContactUs";
import ContactUsDetailsPage from "./views/pages/contact_us/ContactUsDetailsPage";
import FaqTopic from "./views/pages/FaqChatBot/FaqTopic";
import FaqSubTopics from "./views/pages/FaqChatBot/FaqSubTopics";
import FaqAnswer from "./views/pages/FaqChatBot/FaqAnswer";
import CustomizeReview from "./views/pages/review/CustomizeReview";
import DefaultReview from "./views/pages/review/DefaultReview";
import PaymentHistory from "./views/pages/payment_history/PaymentHistory";
import PaymentDetails from "./views/pages/payment_history/PaymentDetails";
import SendEmail from "./views/pages/email/SendEmail";
import Subscribers from "./views/pages/email/Subscribers";
import TermsAndCond from "./views/pages/terms_and_cond/TermsAndCond";
import PrivacyPolicy from "./views/pages/privacy_policy/PrivacyPolicy";
import ResetPassword from "./views/pages/resetPassword/resetPassword";
import RevenueReports from "./views/pages/reports/revenueReports";
import OrderReports from "./views/pages/reports/OrderReports";
import PackageReports from "./views/pages/reports/packageReports";
import TempleReports from "./views/pages/reports/TempleReports";
// import ContactUsDetailsPage from "./views/pages/contact_us/ContactUsDetailsPage";

const Dashboard = lazy(() => import("./views/pages/dashboard/Dashboard"));
const Error404 = lazy(() => import("./views/pages/error/Error404"));
const Temple = lazy(() => import("./views/pages/temple/Temple"));
const TempleDetails = lazy(() => import("./views/pages/temple/TempleDetails"));
const CreateTemple = lazy(() => import("./views/pages/temple/CreateTemple"));
const EditTemple = lazy(() => import("./views/pages/temple/EditTemple"));
const Login = lazy(() => import("./views/pages/auth/Login"));
const Packages = lazy(() => import("./views/pages/packages/Packages"));
const CreatePackage = lazy(() =>
  import("./views/pages/packages/CreatePackage")
);
const EditPackage = lazy(() => import("./views/pages/packages/EditPackage"));
const PackageDetails = lazy(() =>
  import("./views/pages/packages/PackageDetails")
);
const RedirectUser = lazy(() => import("./views/components/Redirect"));
const TrendingTemple = lazy(() =>
  import("./views/pages/trending_temples/TrendingTemple")
);

const SecureRoute = ({ redirectPath = "/login", children }) => {
  if (!localStorage.getItem("token")) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

const AppRoutes = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RedirectUser />} />
        <Route
          path="/dashboard"
          element={
            <SecureRoute>
              <Dashboard />
            </SecureRoute>
          }
        />
        <Route
          path="/temples"
          element={
            <SecureRoute>
              <Temple />
            </SecureRoute>
          }
        />
        <Route
          path="/temple/details/:id"
          element={
            <SecureRoute>
              <TempleDetails />
            </SecureRoute>
          }
        />
        <Route
          path="/temple/create"
          element={
            <SecureRoute>
              <CreateTemple />
            </SecureRoute>
          }
        />
        <Route
          path="/temple/edit/:id"
          element={
            <SecureRoute>
              <EditTemple />
            </SecureRoute>
          }
        />
        <Route
          path="/packages"
          element={
            <SecureRoute>
              <Packages />
            </SecureRoute>
          }
        />
        <Route
          path="/package/create"
          element={
            <SecureRoute>
              <CreatePackage />
            </SecureRoute>
          }
        />
        <Route
          path="/package/edit/:id"
          element={
            <SecureRoute>
              <EditPackage />
            </SecureRoute>
          }
        />
        <Route
          path="/package/details/:id"
          element={
            <SecureRoute>
              <PackageDetails />
            </SecureRoute>
          }
        />
        <Route
          path="/trending-temples"
          element={
            <SecureRoute>
              <TrendingTemple />
            </SecureRoute>
          }
        />
        <Route
          path="/homepage-banner"
          element={
            <SecureRoute>
              <BannerImageSelection />
            </SecureRoute>
          }
        />
        <Route
          path="/customer-shared"
          element={
            <SecureRoute>
              <CustomerShared />
            </SecureRoute>
          }
        />
        <Route
          path="/pricing/form"
          element={
            <SecureRoute>
              <PricingForm />
            </SecureRoute>
          }
        />
        <Route
          path="/user"
          element={
            <SecureRoute>
              <UserList />
            </SecureRoute>
          }
        />{" "}
        <Route
          path="/cart"
          element={
            <SecureRoute>
              <CartList />
            </SecureRoute>
          }
        />
        <Route
          path="/cart/:id"
          element={
            <SecureRoute>
              <CartDetails />
            </SecureRoute>
          }
        />
        <Route
          path="/customize-cart"
          element={
            <SecureRoute>
              <CustomizeCartList />
            </SecureRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <SecureRoute>
              <ResetPassword />
            </SecureRoute>
          }
        />
        <Route
          path="/reports/revenue"
          element={
            <SecureRoute>
              <RevenueReports />
            </SecureRoute>
          }
        />  
        <Route
          path="/reports/order"
          element={
            <SecureRoute>
              <OrderReports />
            </SecureRoute>
          }
        />
        <Route
          path="/reports/package"
          element={
            <SecureRoute>
              <PackageReports />
            </SecureRoute>
          }
        />
        <Route
          path="/reports/temple"
          element={
            <SecureRoute>
              <TempleReports />
            </SecureRoute>
          }
        />
        <Route
          path="/customize-cart/:id"
          element={
            <SecureRoute>
              <CustomizeCartDetails />
            </SecureRoute>
          }
        />
        <Route
          path="/contact-us"
          element={
            <SecureRoute>
              <ContactUs />
            </SecureRoute>
          }
        />
        <Route
          path="/contact-us/:id"
          element={
            <SecureRoute>
              <ContactUsDetailsPage />
            </SecureRoute>
          }
        />
        <Route
          path="/customize-pricing"
          element={
            <SecureRoute>
              <CustomizePricingForm />
            </SecureRoute>
          }
        />
        <Route
          path="/customize-location"
          element={
            <SecureRoute>
              <CustomizeLocation />
            </SecureRoute>
          }
        />
        <Route
          path="/pickup-point"
          element={
            <SecureRoute>
              <PickupPoint />
            </SecureRoute>
          }
        />
        <Route
          path="/pickup-time"
          element={
            <SecureRoute>
              <PickupTime />
            </SecureRoute>
          }
        />
        <Route
          path="/drop-point"
          element={
            <SecureRoute>
              <DropPoint />
            </SecureRoute>
          }
        />
        <Route
          path="/faq-topic"
          element={
            <SecureRoute>
              <FaqTopic />
            </SecureRoute>
          }
        />
        <Route
          path="/faq-sub-topic"
          element={
            <SecureRoute>
              <FaqSubTopics />
            </SecureRoute>
          }
        />
        <Route
          path="/faq-answer"
          element={
            <SecureRoute>
              <FaqAnswer />
            </SecureRoute>
          }
        />
        <Route
          path="/default-review"
          element={
            <SecureRoute>
              <DefaultReview />
            </SecureRoute>
          }
        />
        <Route
          path="/customize-review"
          element={
            <SecureRoute>
              <CustomizeReview />
            </SecureRoute>
          }
        />
        <Route
          path="/payment-history"
          element={
            <SecureRoute>
              <PaymentHistory />
            </SecureRoute>
          }
        />
        <Route
          path="/payment-details"
          element={
            <SecureRoute>
              <PaymentDetails />
            </SecureRoute>
          }
        />
        <Route
          path="/email"
          element={
            <SecureRoute>
              <SendEmail />
            </SecureRoute>
          }
        />
        <Route
          path="/subscribers"
          element={
            <SecureRoute>
              <Subscribers />
            </SecureRoute>
          }
        />
        <Route
          path="/terms-&-condition"
          element={
            <SecureRoute>
              <TermsAndCond />
            </SecureRoute>
          }
        />
           <Route
          path="/privacy-policy"
          element={
            <SecureRoute>
              <PrivacyPolicy />
            </SecureRoute>
          }
        />
        {/* <Route
          path="/reports"
          element={
            <SecureRoute>
              <ReportPage />
            </SecureRoute>
          }
        /> */}
   
        <Route path="/404" element={<Error404 />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
